import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { Box, Button, FormControl, FormLabel, TextField } from '@mui/material'
import {
  createLTIRegistration,
  getLTIIntegration,
  getLTIIssuers,
  updateLTIRegistration,
} from 'providers/mutations'
import { GetLTIIssuers } from 'providers/resources'
import { useNavigateTo } from 'infrastructure/routing'
import { useNotify } from 'shared/ui/Notify'
import { ICreateLTIRegistration } from 'infrastructure/api'
import { green } from '@mui/material/colors'

const AddLTIConfiguration = ({ districtID }: { districtID: number }) => {
  const [issuer, setIssuer] = useState('')
  const [clientID, setClientID] = useState('')
  const [baseURL, setbaseURL] = useState('')
  const [registrationID, setRegistrationID] = useState(-1)
  const [ltiIssuers, setLTIIssuers] = useState<Array<string>>([
    'Add New LMS Integration',
  ])
  const [status, setStatus] = useState('')
  const [lockControl, setLockControl] = useState(false)
  const notify = useNotify()
  const navigate = useNavigateTo()
  const margins = { marginBottom: 10, marginLeft: 5 }
  const textStyle = { fontSize: 15, fontColor: green }
  const fetchLTIIntegration = useCallback(async () => {
    if (districtID) {
      try {
        const integration = await getLTIIntegration(districtID)
        if (integration !== null || integration !== undefined) {
          setClientID(integration.clientid)
          setbaseURL(integration.baseurl)
          setIssuer(integration.issuer)
          setRegistrationID(integration.registrationid)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Error getting LTI integration', err)
      }
    }
  }, [districtID])

  useEffect(() => {
    fetchLTIIntegration()
  }, [fetchLTIIntegration])

  const fetchLTIIssuers = useCallback(async (ltiIssuers: Array<string>) => {
    try {
      const data = await getLTIIssuers()
      if (data) {
        let list: Array<string> = ltiIssuers
        const issuerList = data?.[GetLTIIssuers.key]
        if (issuerList.length > 0) {
          list = list.concat(issuerList)
        }
        setLTIIssuers(list)
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error getting LTI integration', err)
    }
  }, [])

  useEffect(() => {
    fetchLTIIssuers(ltiIssuers)
  }, [fetchLTIIssuers])

  const setLTIIntegration = (event: ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value === 'Add New LMS Integration') {
      navigate(`/admintools/`)
    } else {
      setIssuer(event.target.value)
    }
  }
  const clientIDOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setClientID(e.target.value)
  }
  const baseURLOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setbaseURL(e.target.value)
  }

  const displayError = (msg: string) => {
    notify(msg, { type: 'error' })
  }

  const submit = async () => {
    if (issuer === '') {
      displayError('LMS must be selected')
      return
    }
    if (clientID === '') {
      displayError('Client ID cannot be empty')
      return
    }
    if (baseURL === '') {
      displayError('Base URL cannot be empty')
      return
    }

    const registration: ICreateLTIRegistration = {
      districtid: districtID,
      issuer,
      clientid: clientID,
      baseurl: baseURL,
    }
    if (registrationID === -1) {
      const response = await createLTIRegistration(registration)
      if (response.errors) {
        displayError(response.errors[0].message)
      } else {
        setStatus('Successfuly Added Integration')
        setLockControl(true)
      }
    } else {
      const response = await updateLTIRegistration(registration, registrationID)
      if (response.errors) {
        displayError(response.errors[0].message)
      } else {
        setStatus('Successfuly Updated Integration')
        setLockControl(true)
      }
    }
  }
  return (
    <>
      <FormControl style={{ minWidth: 350 }}>
        <Box
          display={'flex'}
          className={'center-items'}
          style={{ float: 'right' }}
        >
          <span>LMS: </span>
          <select name="Issuers" onChange={setLTIIntegration} value={issuer}>
            <option value=""></option>
            {ltiIssuers.map((val) => (
              <option key={val} value={val}>
                {val}
              </option>
            ))}
          </select>
        </Box>
        <Box sx={{ border: 1, margin: 1 }}>
          <FormLabel
            sx={{
              marginLeft: '0.71em',
              marginTop: '-0.71em',
              paddingLeft: '0.44em',
              paddingRight: '0.44em',
              fontSize: '0.75em',
              width: 'auto',
            }}
          >
            Edit LTI District Information (Registration)
          </FormLabel>
          <div style={{ margin: 3 }}>
            <TextField
              value={clientID}
              label="Client ID"
              variant="outlined"
              onChange={clientIDOnChange}
              size="small"
              style={margins}
              disabled={lockControl}
              inputProps={{
                'aria-label': 'Client ID',
              }}
            />
            <TextField
              value={baseURL}
              label="Base URL"
              variant="outlined"
              onChange={baseURLOnChange}
              size="small"
              style={margins}
              disabled={lockControl}
              inputProps={{
                'aria-label': 'Base URL',
              }}
            />
          </div>
        </Box>
        <Button
          onClick={submit}
          variant="outlined"
          color="secondary"
          disabled={lockControl}
        >
          Create LTI Connection
        </Button>
      </FormControl>
      <span style={textStyle}>{status}</span>
    </>
  )
}

export default AddLTIConfiguration
